import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DealerInterface } from "../../../interfaces/dealerInterface";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { dealerApi } from "../services/dealer.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  DEALER_MESSAGES_ERROR,
  DEALER_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSaveDealerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<DealerInterface>, Error, DealerInterface>({
    mutationFn: (dealer) => dealerApi.saveDealer(dealer),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(DEALER_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(DEALER_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["dealers"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["dealer-by-id", variables._id],
        });
      }
    },
    onError: () => {
      errorNotification(DEALER_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
